module.exports = __webpack_public_path__ + "img/azure.a4869265.png";